// InstructionsOverlay.js
import React from "react";

function InstructionsOverlay({ onClose }) {
	return (
		<div className="absolute top-0 left-0 w-full h-full z-10">
			{/* Background image layer */}
			<div className="relative w-full h-full overflow-hidden bg-black/30">
				<img
					src="https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/hornelius_no_bg.png"
					alt="Background"
					className="w-full h-full object-cover opacity-10 pointer-events-none"
				/>
			</div>

			{/* Content layer (your instructions) */}
			<div className="
  absolute 
  top-1/2 left-1/2 
  transform 
  -translate-x-1/2
  -translate-y-1/2       /* Center on mobile */
  w-[90%]
  max-w-2xl             /* Optional, to limit width on large screens */
  max-h-[80vh]          /* Don’t exceed 80% of the viewport height */
  p-4 
  rounded 
  overflow-auto
  text-xs sm:text-sm md:text-base
  text-monadWhite 
  pointer-events-auto 
  z-10
"
>
				<h2 className="font-bold mb-2 text-center">Choose a background image to begin</h2>
				<div className="flex justify-center mb-2">
					<ul className="list-disc list-inside text-left">
						<li>Upload your own image</li>
						<li>Popular imgflip meme template</li>
						<li>NFTs from wallet address</li>
						<li>Sappy Seals Meme Machine</li>
					</ul>
				</div>

				<h2 className="font-bold mb-2 text-center">Add text and style it</h2>
				<h2 className="font-bold mb-2 text-center">Add any of the available assets to your meme</h2>
				<h2 className="font-bold mb-2 text-center">Deep fry it | Download it</h2>
				<h2 className="font-bold mb-2 text-center">
					Built by{" "}
					<a
						href="https://x.com/hornelius"
						target="_blank"
						rel="noopener noreferrer"
						className="text-monadLightPurple hover:underline"
					>
						hornelius.eth{" "}
					</a>
					|{" "}
					<a
						href="https://x.com/sealuminati"
						target="_blank"
						rel="noopener noreferrer"
						className="text-monadLightPurple hover:underline"
					>
						sealuminati
					</a>{" "}
					dev
				</h2>
			</div>
		</div>
	);
}

export default InstructionsOverlay;
